//this will contain all data for the portfolio carosel 
export const data = [
{
  name: "When we clean scheduling app",
  details: "This was a collabrative project. Me and 4 other people created an app that can schedule employees, with unique UI and working user authentication.",
  link: "https://when-we-clean.herokuapp.com/",
  image: "./images/projects/when-we-clean.png",
},
{
  name: "spotifind",
  details: "This was another collaboration where we created an app where you can listen to songs from spotify.",
  link: "https://nickkeller316.github.io/Project1/",
  image: "./images/projects/spot.png",
},
{
  name: "Note taking app",
  details: "This is just a simple application that allows you to take notes",
  link: "https://note-taker-main.herokuapp.com/",
  image: "./images/projects/note.png",
},
{
  name: "PWA budget tracker",
  details: "This was the first PWA that I made and you can use it to track your budget and finances with mongodb",
  link: "https://progressive-budget-track.herokuapp.com/",
  image: "./images/projects/budget.png",
},
{
  name: "React employee directory",
  details: "This was my first react application, this is an application that uses the randomuser api to generate random users and you can search and filter them",
  link: "https://milagro12090.github.io/React-employee-directory/",
  image: "./images/projects/employee.png",
},
{
  name: "fitness tracker",
  details: "This is a simple express application where you can create new workouts and keep track of your current workouts.",
  link: "https://fitness-scheduler.herokuapp.com/",
  image: "./images/projects/fitness.png",
},
];

